import * as Yup from 'yup';
import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';

export type TabId = 'lecturer' | 'about';

export interface Values {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    country: string;
    image: string;
    about: string;
    link: string;
    liveLink: string;
}

export const initialValues: Values = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    image: teamMemberPhoto,
    about: '',
    link: '',
    liveLink: '',
};

export const inputDefaults = {events: {}, className: '', forwardRef: null} as const;

export const buildSchema = (requiredMessage: string) =>
    Yup.object({
        firstName: Yup.string().trim().required(requiredMessage),
    });
